import { useMutation, useQueryClient, useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";
import toast from "react-hot-toast";
import createNotification from "shared/@utils/createNotification";

export function useIBOFile(ibo) {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, refetch } = useQuery(
    ["platforms"],
    () =>
      makeAuthedRequest(`/ibo/${ibo}/platform-status`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    { staleTime: 0 }
  );

  const platformStatusPut = useMutation((escalateObj) =>
    makeAuthedRequest(`/ibo/${ibo}/platform-status`, {
      method: "PUT",
      body: JSON.stringify(escalateObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return {
    data,
    isLoading,
    refetch,
    platformStatusPut,
  };
}
